import { render, staticRenderFns } from "./TmsPartInfo.vue?vue&type=template&id=20a0a49b"
import script from "./TmsPartInfo.ts?vue&type=script&lang=ts&external"
export * from "./TmsPartInfo.ts?vue&type=script&lang=ts&external"
import style0 from "./TmsPartInfo.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports